// src/components/Login.js
import React, { useState } from 'react';
import { useApp } from '../contexts/AppContext';
import { useTheme } from '../contexts/ThemeContext';
import { useResponsive } from '../hooks/useResponsive';

export default function Login() {
  const { login } = useApp();
  const { theme, toggleTheme, isDark } = useTheme();
  const { isMobile } = useResponsive();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await login(email, password);
    if (!result.success) setError(result.error);
    setLoading(false);
  };

  return (
    <div style={{ position: 'relative', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', background: theme.bgApp }}>
      {/* Grid background */}
      <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', backgroundImage: `linear-gradient(${theme.gridLine} 1px, transparent 1px), linear-gradient(90deg, ${theme.gridLine} 1px, transparent 1px)`, backgroundSize: '48px 48px' }} />
      <div style={{ position: 'fixed', top: '-20%', left: '-10%', width: '60%', height: '60%', background: 'radial-gradient(ellipse, rgba(249,115,22,0.07) 0%, transparent 60%)', borderRadius: '50%', pointerEvents: 'none' }} />

      {/* Theme toggle top-right */}
      <button onClick={toggleTheme} style={{ position: 'fixed', top: isMobile ? 12 : 20, right: isMobile ? 12 : 20, zIndex: 10, background: theme.bgCard, border: `1px solid ${theme.border}`, borderRadius: 10, padding: isMobile ? '7px 10px' : '8px 14px', color: theme.textSecondary, cursor: 'pointer', fontSize: 12, fontFamily: 'DM Sans, sans-serif', display: 'flex', alignItems: 'center', gap: 6 }}>
        {isDark ? '☀️' : '🌙'} {!isMobile && (isDark ? 'Light' : 'Dark')}
      </button>

      <div style={{ position: 'relative', zIndex: 1, width: '100%', maxWidth: 440, padding: isMobile ? '16px' : '20px' }}>
        <div style={{ background: theme.bgCard, border: `1px solid ${theme.borderInput}`, borderRadius: isMobile ? 16 : 20, padding: isMobile ? '28px 22px' : '40px 36px', boxShadow: theme.shadow }}>

          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: isMobile ? 24 : 32 }}>
            <div style={{ width: 48, height: 48, background: 'rgba(249,115,22,0.1)', border: '1px solid rgba(249,115,22,0.2)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path d="M4 20L14 8L20 15L24 10" stroke="#f97316" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="24" cy="10" r="2.5" fill="#f97316"/>
                <path d="M2 22h24" stroke="#f97316" strokeWidth="1.5" strokeOpacity="0.4"/>
              </svg>
            </div>
            <div>
              <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: 20, color: theme.textPrimary, letterSpacing: '-0.5px' }}>ShipDoTrack</div>
              <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: 2, color: '#f97316', marginTop: -2 }}>FLEET MANAGEMENT</div>
            </div>
          </div>

          <h1 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 26, color: theme.textPrimary, marginBottom: 6, letterSpacing: '-0.5px' }}>Welcome back</h1>
          <p style={{ fontSize: 14, color: theme.textMuted, marginBottom: 28 }}>Sign in to your account to continue</p>

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
              <label style={{ fontSize: 12, fontWeight: 500, color: theme.textMuted, letterSpacing: '0.5px', textTransform: 'uppercase' }}>Email Address</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" required
                style={{ background: theme.bgInput, border: `1.5px solid ${theme.borderInput}`, borderRadius: 10, padding: '12px 14px', color: theme.textPrimary, fontSize: 14, outline: 'none', fontFamily: 'DM Sans, sans-serif' }}
                onFocus={e => e.target.style.borderColor = '#f97316'} onBlur={e => e.target.style.borderColor = theme.borderInput} />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
              <label style={{ fontSize: 12, fontWeight: 500, color: theme.textMuted, letterSpacing: '0.5px', textTransform: 'uppercase' }}>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required
                style={{ background: theme.bgInput, border: `1.5px solid ${theme.borderInput}`, borderRadius: 10, padding: '12px 14px', color: theme.textPrimary, fontSize: 14, outline: 'none', fontFamily: 'DM Sans, sans-serif' }}
                onFocus={e => e.target.style.borderColor = '#f97316'} onBlur={e => e.target.style.borderColor = theme.borderInput} />
            </div>

            {error && <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 8, padding: '10px 14px', color: '#f87171', fontSize: 13 }}>{error}</div>}

            <button type="submit" disabled={loading}
              style={{ background: 'linear-gradient(135deg, #f97316, #ea580c)', border: 'none', borderRadius: 10, padding: '13px', color: '#fff', fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 15, cursor: 'pointer', marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {loading ? <span style={{ width: 18, height: 18, border: '2px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', borderRadius: '50%', animation: 'spin 0.7s linear infinite', display: 'inline-block' }} /> : 'Sign In'}
            </button>
          </form>

          <div style={{ marginTop: 28, padding: '14px 16px', background: theme.bgInput, border: `1px solid ${theme.border}`, borderRadius: 10, fontSize: 12, color: theme.textFaint, textAlign: 'center', lineHeight: 1.6 }}>
            Contact your system administrator<br/>if you need access or have forgotten your password.
          </div>
        </div>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
